import { useState, useEffect } from "react";
import { Container, Row, Col, Spinner, ProgressBar } from "react-bootstrap";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import CardContainer from "../components/CardContainer";
import { Link } from "react-router-dom";
import { apiFetch } from "../api";
import HomeImg from '../assets/Home.png';
import HomeImg1 from '../assets/Home-1.png';
import HomeImg2 from '../assets/home-2.png';
import HomeImg3 from '../assets/home-3.png'; 
import HomeImg4 from '../assets/Home-4.png'; 

const carouselImages = [
  {
    id: 0,
    src: HomeImg,
    alt: "Label-Aadvi Collection 1"
  },
  {
    id: 1,
    src: HomeImg1,
    alt: "Label-Aadvi Collection 2"
  },
  {
    id: 2,
    src: HomeImg2,
    alt: "Label-Aadvi Collection 3"
  },
  {
    id: 3,
    src: HomeImg3,
    alt: "Label-Aadvi Collection 4"
  },
  {
    id: 4,
    src: HomeImg4,
    alt: "Label-Aadvi Collection 5"
  }
];
// Home Component
const Home = (props) => {
  const { searchQuery = "" } = props;
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  // Auto slide interval
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Manual slide control
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };
  // Fetch products from API
  async function fetchProductData() {
    setLoading(true);
    try {
      const data = await apiFetch("/api/products/all");
      setProducts(data.data || []);
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]);
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchProductData();
  }, []);

  // Group products by category
  const groupedProducts = products.reduce((acc, product) => {
    // Group products by their category name
    const category = product.category?.name || "Uncategorized";
    if (!acc[category]) {
      acc[category] = [];
    }
    // Add product to the appropriate category array
    acc[category].push(product);
    return acc;
  }, {});

  // Filter products by search query
  const filterBySearch = (products) => {
    if (!searchQuery) return products;
    return products.filter((product) =>
      product.name.toLowerCase().includes(searchQuery.toLowerCase().trim())
    );
  };

  // Handle "Show More" button click
  const handleShowMore = (category) => {
    navigate(`/products?category=${encodeURIComponent(category)}`);
  };

  return (
    <>
      {/* Carousel Section */}
      <div className="mask flex-center">
        <Container>
          <Row className="align-items-center">
            {/* Left Column - Text Content */}
            <Col
              md={7}
              xs={12}
              className="order-md-1 order-2"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <span className="carousel-title display-4">
                <strong>
                  <span style={{ color: "#82278A" }}>Welcome to Label-</span>{" "}
                  <br />
                  Aadvi{" "}
                </strong>
              </span>
              <p className="mt-2">
                Best Quality Fabrics - Classy Designs - Affordable Pricing
              </p>
              <div className="home-btn">
                <Link
                  to="/products"
                  className="btn img-btn p-3"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  Shop Collection
                </Link>
              </div>
            </Col>

            {/* Right Column - Carousel */}
            <Col
              md={5}
              xs={12}
              className="order-md-2 order-1"
              data-aos="fade-left"
              data-aos-delay="300"
            >
              <div
                className="image-carousel"
                style={{
                  position: "relative",
                  width: "100%",
                  borderRadius: "10px",
                  overflow: "hidden",
                  aspectRatio: 2748 / 1363,
                }}
              >
                {/* Carousel Images */}
                {carouselImages.map((img, index) => (
                  <div
                    key={img.id}
                    className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      opacity: index === currentSlide ? 1 : 0,
                      transition: "opacity 0.5s ease-in-out",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={img.src}
                      className="img-fluid"
                      alt={img.alt}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                    />
                  </div>
                ))}
                {/* Dots Indicator */}
                <div
                  className="carousel-dots"
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    gap: "10px",
                    zIndex: 10,
                  }}
                >
                  {carouselImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToSlide(index)}
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        border: "none",
                        background: index === currentSlide ? "#F47735" : "rgba(255,255,255,0.5)",
                        cursor: "pointer",
                        padding: 0,
                      }}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Product Sections */}
      {loading ? (
        <div className="text-center py-5 w-100">
          <div className="text-center">
            <Spinner 
              animation="border" 
              className="loading-spinner" 
              style={{ color: "#82278A", width: '3rem', height: '3rem' }} 
            />
            <div className="mt-3">
              <p className="text-purple mb-2">Loading products...</p>
              <ProgressBar 
                now={100} 
                animated 
                style={{ height: '4px', width: '200px', margin: '0 auto' }}
                variant="purple"
              />
            </div>
          </div>
        </div>
      ) : (
        // Render product categories
        Object.keys(groupedProducts).map((category) => {
          const categoryProducts = filterBySearch(groupedProducts[category]);
          
          // Skip rendering if no products match the search query
          if (categoryProducts.length === 0) return null;
          
          return (
            <div key={category} id="card-container-section">
              <CardContainer
                posts={categoryProducts}
                loading={loading}
                title={category}
              />
            </div>
          );
        })
      )}
    </>
  );
};

export default Home;